import SURVEY_CHART_TYPE from '../constants/SurveyChartTypes';
import SURVEY_VALUE_PRESENTATION_TYPE from '../constants/SurveyValuePresentationTypes';
import constants from '@shared-styles/constants.module.scss';
import AUTO_CALCULATED_QUESTION_IDS from '../constants/SurveyChartAutoCalculatedFields';
import SURVEY_RESULT_LABEL_TYPE from '../constants/SurveyResultLabelType';

const AutoCalculatedSurveyMap = {
  [AUTO_CALCULATED_QUESTION_IDS.NPS]: {
    createResult: (years, results) => ({
      Label: 'NPS',
      Order: results.length + 1,
      Color: constants.organizationColor,
      ChartType: SURVEY_CHART_TYPE.LINE,
      Presentation: SURVEY_VALUE_PRESENTATION_TYPE.SignedInteger,
      IsAutoCalculated: true,
      LabelType: SURVEY_RESULT_LABEL_TYPE.Nps,
      SurveyResultValues: years.map(year => ({
        Year: year,
        Value: 0
      }))
    }),

    getValue: ({ year, allResults }) => {
      const promoters = allResults.find(r => r.LabelType === SURVEY_RESULT_LABEL_TYPE.Promoters);
      const detractors = allResults.find(r => r.LabelType === SURVEY_RESULT_LABEL_TYPE.Detractors);

      const promotersYearValue = promoters.SurveyResultValues.find(v => v.Year === year).Value;
      const detractorsYearValue = detractors.SurveyResultValues.find(v => v.Year === year).Value;

      return promotersYearValue - detractorsYearValue;
    }
  }
};

export default AutoCalculatedSurveyMap;
